import { render, staticRenderFns } from "./CreditClassRoom.vue?vue&type=template&id=58a1f864&"
import script from "./CreditClassRoom.vue?vue&type=script&lang=js&"
export * from "./CreditClassRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports